<template>
  <v-switch
    color="primary"
    hide-details
    label="One Page View"
    v-model="onePage"
    @change="onOnePageViewChange"
    class="my-0 py-0"
  ></v-switch>
</template>
<script>
export default {
  name: "OnePageViewSwitch",
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
    settingName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      onePage: this.$store.getters.localSettings(this.settingName, this.value),
    };
  },
  methods: {
    onOnePageViewChange(event) {
      this.$store.dispatch("updateLocalSettings", {
        [this.settingName]: event,
      });
      this.$emit("input", event);
    },
  },
  mounted() {
    this.onePage && this.$emit("input", true);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/shared/OnePageViewSwitch.vue